import { isAxiosError } from 'axios'
import {
  bffCrmPersonComplexitySegmentation,
  type BffCrmPersonComplexitySegmentationRetrieveResponse,
} from '@fireflyhealth/api'
import { useQuery } from '~/shared/hooks/query'
import { required } from '~/shared/lib/required'
type ComplexitySegmentation = BffCrmPersonComplexitySegmentationRetrieveResponse

export const useComplexitySegmentation = (personId: number | undefined) => {
  return useQuery(
    personId != null
      ? bffCrmPersonComplexitySegmentation.retrieveQueryKey({ person_id: personId })
      : ['bffCrmPersonComplexitySegmentation', personId],
    async (): Promise<ComplexitySegmentation | null> => {
      try {
        const response = await bffCrmPersonComplexitySegmentation.retrieve({
          person_id: required(personId, 'a person id'),
        })
        return response.data
      } catch (error) {
        if (isAxiosError(error) && error.response?.status === 404) {
          // 404 means no segmentation row exists — not an error condition.
          return null
        }
        throw error
      }
    },
    {
      enabled: personId != null,
      staleTime: 5 * 60 * 1000, // 5 min — refreshed on next page load; pipeline runs daily
    },
  )
}
